export const FETCH_SITES_REQUEST = 'sites/FETCH_SITES_REQUEST';
export const FETCH_SITES_SUCCESS = 'sites/FETCH_SITES_SUCCESS';
export const FETCH_SITES_FAILURE = 'sites/FETCH_SITES_FAILURE';

export const FETCH_TOP_SITES_REQUEST = 'sites/FETCH_TOP_SITES_REQUEST';
export const FETCH_TOP_SITES_SUCCESS = 'sites/FETCH_TOP_SITES_SUCCESS';
export const FETCH_TOP_SITES_FAILURE = 'sites/FETCH_TOP_SITES_FAILURE';

export const FETCH_CATEGORIES_REQUEST = 'sites/FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'sites/FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'sites/FETCH_CATEGORIES_FAILURE';

export const FETCH_SITE_REQUEST = 'sites/FETCH_SITE_REQUEST';
export const FETCH_SITE_SUCCESS = 'sites/FETCH_SITE_SUCCESS';
export const FETCH_SITE_FAILURE = 'sites/FETCH_SITE_FAILURE';

export const FETCH_REVIEWS_REQUEST = 'sites/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'sites/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_FAILURE = 'sites/FETCH_REVIEWS_FAILURE';

export const FETCH_SPONSORED_REQUEST = 'sites/FETCH_SPONSORED_REQUEST';
export const FETCH_SPONSORED_SUCCESS = 'sites/FETCH_SPONSORED_SUCCESS';
export const FETCH_SPONSORED_FAILURE = 'sites/FETCH_SPONSORED_FAILURE';

export const FETCH_SIMILAR_REQUEST = 'sites/FETCH_SIMILAR_REQUEST';
export const FETCH_SIMILAR_SUCCESS = 'sites/FETCH_SIMILAR_SUCCESS';
export const FETCH_SIMILAR_FAILURE = 'sites/FETCH_SIMILAR_FAILURE';

export const CLEAR_SITE_STATE = 'sites/CLEAR_SITE_STATE';

